import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const AppLeftNav = () =>
  import(/* webpackChunkName: "4-feat-mobile-nav-overlay" */ './AppLeftNav').then((m) => ({ default: m.AppLeftNav }));

const LoadableAppLeftNav: ComponentType = lazyLoadOnRender({ loader: AppLeftNav });
export default LoadableAppLeftNav;
